module.exports = __webpack_public_path__ + "img/home_2.a2c310e3.png";